<template>
  <div class="special-topic-detail">
    <xi-top></xi-top>
      <div class="topic-banner" :style="{backgroundImage: 'url(' + imgPath + ')'}"></div>
      <div class="guide-block-wrapper">
          <div class="guide-block-inner-wrapper">
              <span class="guide-title" v-if="data.guideTitle">{{ data.guideTitle }}</span>
             <div v-html="data.guideContent"></div>
          </div>
      </div>
      <div class="topic-block-wrapper">
          <div class="topic-block-inner-wrapper">
              <span class="topic-title">{{ data.majorTitle }}</span>
              <div v-for="topic in data.majorRequirement" :key="topic.id" class="topic-block">
                  <div v-if="topic.authorType === 'author'" key="topic.id" class="topic-group-author-wrapper">
                      <img :src="`${$store.state.UPLOAD_IMG_HOST}${topic.logo}`">
                      <div class="author-content">
                          <span class="author-title">{{ topic.name }}</span>
                          <p class="author-desc">{{ topic.description }}</p>
                      </div>
                  </div>
                  <div v-if="topic.authorType === 'press'" key="topic.id" class="topic-group-press-wrapper">
                      <img :src="`${$store.state.UPLOAD_IMG_HOST}${topic.logo}`">
                      <div class="press-content">
                          <span class="press-title">{{ topic.name }}</span>
                          <p class="press-desc">{{ topic.description }}</p>
                      </div>
                  </div>
                  <div class="topic-work">
                      <span v-if="topic.authorType" class="works-title">优选作品</span>
                      <div v-for="work in topic.requirementList" :key="work.requirementId" class="work-wrapper">
                          <a :href="`${$store.state.A_PC_HOST}/requirement/${work.requirementId}/candidate`"><img :src="handleCover(work.coverPath)"></a>
                          <div class="work-content-wrapper">
                              <a class="work-title" :href="`${$store.state.A_PC_HOST}/requirement/${work.requirementId}/candidate`">{{ work.requirementName }}</a>
                              <span class="work-author">{{ work.author }} 著</span>
                              <span class="work-type">{{ work.categoryName }}</span>
                              <p class="work-desc">{{ work.description }}</p>
                              <div class="work-footer">
                                  <div class="work-footer-left">
                                      <span class="work-pay">{{ getPayLabel(work) }}</span>
                                      <span class="work-pay-type">{{ getPayTypeLabel(work) }}</span>
                                  </div>
                                  <div class="work-footer-right">
                                      <span class="work-audition-time-remaining">{{ getRemainingLabel(work) }}</span>
                                      <span class="work-audition-person-time">{{ work.candidateOrTaskWorkNum }}人参选</span>
                                      <a class="work-audition-btn" :href="`${$store.state.A_PC_HOST}/requirement/${work.requirementId}/candidate`">去参加海选</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="sub-topic-block-wrapper">
        <div class="sub-topic-block-inner-wrapper">
            <span class="sub-topic-title">{{ data.moreTitle }}</span>
            <div class="sub-topic-works-wrapper">
                <a :href="`${$store.state.A_PC_HOST}/requirement/${work.requirementId}/candidate`" v-for="work in data.moreRequirement.requirementList" :key="work.requirementId" class="sub-topic-work-wrapper">
                    <img :src="handleCover(work.coverPath)">
                    <div class="sub-topic-work-content-wrapper">
                        <div class="sub-topic-work-first">
                            <span class="sub-topic-work-pay">{{ getPayLabel(work) }}</span>
                            <span class="sub-topic-work-pay-type">{{ getPayTypeLabel(work) }}</span>
                        </div>
                        <span class="sub-topic-work-second">{{ work.requirementName }}</span>
                        <span class="sub-topic-work-third">{{ work.author }} 著</span>
                        <span class="sub-topic-work-fourth">{{ work.categoryName }}</span>
                        <div class="sub-topic-work-fifth">
                            <span class="sub-topic-audition-time-remaining">{{ getRemainingLabel(work) }}</span>
                            <span class="sub-topic-audition-person-time">{{ work.candidateOrTaskWorkNum }}人参选</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
      </div>
      <div class="topic-detail-footer-wrapper">
          <div class="topic-detail-footer-inner-wrapper">
              <a :href="`${$store.state.A_PC_HOST}/requirementview`" class="more-block more-requirement">
                  <span>没看够？查看所有海选任务</span>
                  <span class="go">GO</span>
              </a>
              <router-link :to="{name: 'specialTopicList'}" class="more-block topic-list">
                  <span>更多精品专题在这里</span>
                  <span class="go">GO</span>
              </router-link>
          </div>
      </div>
    <xi-footer></xi-footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import XiFooter from '../components/Footer.vue';
  import XiTop from '../components/Top.vue';
  import shave from 'shave';
  export default {
    components: {
      axios,
      XiFooter,
      XiTop
    },
    data() {
      return {
        imgPath: '',
        data: {
          moreRequirement: {
            requirementList: []
          },
          banner: {

          }
        }
      }
    },
    methods: {
      getDetailInfo () {
        axios.get(`/api/subject/detail/${this.$route.params.id}`).then(res => {
          if (res.data.code === 200) {
            this.data = res.data.data;
            this.imgPath = this.$store.state.UPLOAD_IMG_HOST + this.data.banner;
          }
        });
      },
      shave() {
        shave('p.work-desc', 80);
      },
      getRemainingLabel (work) {
        let label = '';
        if(work.viewStatusId !== 1) {
          label = '海选已结束'
        } else {
          label = '海选剩余' + work.sampleRemainTime;
        }
        return label;
      },
      getPayLabel (work) {
        let pay = '';
        let percentage = '';
        if (work.prePayDirectMultiplier) {
          pay = '￥' + work.prePayDirectMultiplier + '/小时';
        }
        if (work.royaltyShareRatioDecimal) {
          percentage = work.royaltyShareRatioDecimal * 100 + '%';
        }
        return (pay && percentage)? (pay + '+' + percentage): (pay + percentage);
      },
      getPayTypeLabel (work) {
        let pay = '';
        let percentage = '';
        if (work.prePayDirectMultiplier) {
          pay = '底薪';
        }
        if (work.royaltyShareRatioDecimal) {
          percentage = '分成';
        }
        return (pay && percentage)? pay + '+' + percentage: pay + percentage;
      },
      handleCover(path) {
        let reg = new RegExp('^http://');
        return path? (reg.test(path)? path:this.$store.state.UPLOAD_IMG_HOST + path)
          : this.$store.state.IMG_HOST + 'bookCoverDefault.png';
      },
      setXMLog () {
        xmLog('pv.create', {
          item: "有声化平台专题页"
        }),
          xmLog("pv.send", "event", {
            serviceId: "aBookView",
            item: "有声化平台专题页"
          })
      },
    },
    beforeMount() {
      this.getDetailInfo();
      this.setXMLog();
    },
    updated () {
      this.shave();
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/icons.scss";
    @import "../../sass/specialTopic/detail.scss";
</style>



// WEBPACK FOOTER //
// Detail.vue?3d7dd464